import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Button } from '@material-ui/core'
import { Save } from '@material-ui/icons'
import { injectIntl } from 'react-intl'
import { Map } from 'immutable'
import messages from 'routes/App/Apps/DataBrowser/translate'
import { exportToCsv } from 'reducers/dataBrowser/reducer'
import withPromise from 'helpers/withPromise'

class ExportButton extends Component {
  constructor(props) {
    super(props)

    this.state = {
      isDisableExportButton: true,
    }
  }

  componentDidMount() {
    const {
      activeProdAndHealthType,
      activeEnvironmentType,
      activeLogbookType,
    } = this.props

    this.setDisableExportButton(
      !(
        activeProdAndHealthType.get('value') ||
        activeEnvironmentType.get('name') ||
        activeLogbookType.get('id')
      ),
    )
  }

  shouldComponentUpdate(nextProps) {
    const {
      activeProdAndHealthType: curPaHType,
      activeEnvironmentType: curEnvType,
      activeLogbookType: curLbType,
    } = this.props
    const {
      activeProdAndHealthType: nextPaHType,
      activeEnvironmentType: nextEnvType,
      activeLogbookType: nextLbType,
    } = nextProps

    if (
      curPaHType !== nextPaHType ||
      curEnvType !== nextEnvType ||
      curLbType !== nextLbType
    ) {
      this.setDisableExportButton(
        !(
          nextPaHType.get('value') ||
          nextEnvType.get('name') ||
          nextLbType.get('id')
        ),
      )

      return false
    }

    return true
  }

  setDisableExportButton = isDisableExportButton =>
    this.setState({ isDisableExportButton })

  onExportBtnClick = () => {
    this.setDisableExportButton(true)

    const {
      activeSite,
      dateRange,
      activeProdAndHealthType,
      activeEnvironmentType,
      activeLogbookType,
      exportToCsv,
    } = this.props
    const productionAndHealth = activeProdAndHealthType.get('value')
    const sensor = activeEnvironmentType.get('id')
    const sensorType = activeEnvironmentType.get('sensor_type_id')
    const event = activeLogbookType.get('id')
    const params = {
      site: activeSite,
      from: dateRange.get('startDate').format('YYYY-MM-DD'),
      to: dateRange.get('endDate').format('YYYY-MM-DD'),
    }

    if (productionAndHealth) {
      params.production_and_health = productionAndHealth
    }

    if (sensor) {
      params.sensor = sensor
    }

    if (sensorType) {
      params.sensor_type = sensorType
    }

    if (event) {
      params.event = event
    }

    withPromise(exportToCsv, params).then(() =>
      this.setDisableExportButton(false),
    )
  }

  render() {
    const {
      intl: { formatMessage },
    } = this.props
    const { isDisableExportButton } = this.state

    return (
      <Button
        disabled={isDisableExportButton}
        onClick={this.onExportBtnClick}
        variant="contained"
        color="primary"
        classes={{
          root: 'export-button',
        }}>
        <Save />
        {formatMessage(messages.exportToCsv)}
      </Button>
    )
  }
}

ExportButton.propTypes = {
  activeSite: PropTypes.number,
  dateRange: PropTypes.instanceOf(Map),
  activeProdAndHealthType: PropTypes.instanceOf(Map),
  activeEnvironmentType: PropTypes.instanceOf(Map),
  activeLogbookType: PropTypes.instanceOf(Map),
}

export default connect(
  state => ({
    activeSite: state.getIn(['profile', 'siteId']),
    dateRange: state.getIn(['sensor', 'dateRange']),
    activeProdAndHealthType: state.getIn(['dataBrowser', 'activeProductions']),
    activeEnvironmentType: state.getIn(['dataBrowser', 'activeEnvironment']),
    activeLogbookType: state.getIn(['dataBrowser', 'activeLogbookType']),
  }),
  {
    exportToCsv,
  },
)(injectIntl(ExportButton))
